import { Col, Flex, Row, Typography } from 'antd';
import TripTracking from '../../VehicleMonitoring/components/TripTracking';
import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer';
import { DARK, TRIP_VIDEO_STATUS } from '../../../utilities/constants';
import EmptyCard from '../../../components/EmptyCard/EmptyCard';
import { useTheme } from '../../../context/ThemeContext';
import Icon from '@ant-design/icons';
import { ReactComponent as DmsVideoEmpty } from '../../../assets/icons/dms-video-empty.svg';
import { ReactComponent as DmsVideoEmptyWhite } from '../../../assets/no-data-white.svg';
import { formatDateTime } from '../../../utilities/commonFunctions';
import PropTypes from 'prop-types';

const { Text } = Typography;

function FragmentVideo({ selectedTrip, fragmentDetails }) {
  const { theme } = useTheme();
  return (
    <>
      <Flex justify="space-between">
        <Text>{formatDateTime(selectedTrip?.actual_trip_start_time)}</Text>
        <Text>{formatDateTime(selectedTrip?.actual_trip_end_time)}</Text>
      </Flex>
      <Row gutter={0} className="full-height">
        <Col xs={{ span: 24 }} xl={{ span: 17 }} className="video-col">
          {fragmentDetails &&
          fragmentDetails?.vod_status === TRIP_VIDEO_STATUS.AVAILABLE ? (
            <Flex vertical style={{ backgroundColor: '#000000' }}>
              <div style={{ position: 'relative', width: '100%' }}>
                <VideoPlayer
                  url={fragmentDetails?.video_s3_link}
                  width="100%"
                  height="46vh"
                  feature="vod"
                  disableVolume={false}
                />
              </div>
            </Flex>
          ) : (
            <EmptyCard
              image={
                <Icon
                  component={
                    theme === DARK ? DmsVideoEmpty : DmsVideoEmptyWhite
                  }
                />
              }
              description={
                <Flex vertical gap={20}>
                  <Text strong>No video selected</Text>
                  <Text style={{ color: '#979EA4' }}>
                    Retrieve video footage to start playing
                  </Text>
                </Flex>
              }
            />
          )}
        </Col>
        <Col xs={{ span: 24 }} xl={{ span: 7 }}>
          <TripTracking selectedTrip={selectedTrip} />
        </Col>
      </Row>
    </>
  );
}

FragmentVideo.propTypes = {
  selectedTrip: PropTypes.object,
  fragmentDetails: PropTypes.object,
};

export default FragmentVideo;
